angular.module("ainapp")
    .controller("costCenterDesignController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Cost Center Design";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.switchTab = function (data) {

                $scope.SelectedCost = data;
                $scope.Vdesign = {};

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetCostCenterDesign(data.Id).then(function (response) {
                    if (response.data != null && response.data != "") {
                        $scope.VoucherDesign = response.data;
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }


            $scope.Init = function () {

                $scope.load = false;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                $scope.VoucherDesign = {};

                $scope.SelectedCost = {};

                $scope.Costcenters = [];
                MainService.CostCenterList().then(function (response) {
                    $scope.Costcenters = response.data;
                    $scope.switchTab(response.data[0]);
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })


            }
            $scope.Init();





            $scope.SaveData = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                $scope.load = true;
                $scope.VoucherDesign.CostCenterId = $scope.SelectedCost.Id;
                MainService.AddCostCenterDesign($scope.VoucherDesign).then(function (response) {
                    $scope.load = false;
                    if (response) {
                        toastr.success("Success");
                        $scope.switchTab($scope.SelectedCost);
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }



      }]);
